export default __webpack_public_path__ + "static/media/surfers-mobile.be9dd2f2.png";